"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTxRawEIP712 = void 0;
const proto_1 = require("@tharsis/proto");
function createTxRawEIP712(body, authInfo, extension) {
    body.extension_options.push((0, proto_1.createAnyMessage)(extension));
    return (0, proto_1.createTxRaw)(body.serializeBinary(), authInfo.serializeBinary(), [
        new Uint8Array(),
    ]);
}
exports.createTxRawEIP712 = createTxRawEIP712;
//# sourceMappingURL=txRaw.js.map